import * as React from "react";
import {Field} from "react-final-form";
import {TiposIdentificacion} from "../../documentos/modelo/TiposIdentificacion";

export default class TipoIdentificacion extends React.Component<TipoIdentificacionProps> {

    render() {
        const {className, excluir} = this.props;
        const tiposIdentificacion = this.filtrarTiposIdentificacion(excluir);
        return (
            <Field name={this.props.name}>
                {({input, meta}) => (
                    <div>
                        <select {...input} className={className ? className.concat(" form-control") : "form-control"}>
                            <option value={""}>Selecciona...</option>
                            {tiposIdentificacion.map(tipo => {
                                return <option key={tipo.id} value={tipo.symbol}>{tipo.name}</option>;
                            })}
                        </select>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }

    filtrarTiposIdentificacion = (excluir: Array<string>) => {
        return TiposIdentificacion.filter(tc => {
            return !excluir || excluir.indexOf(tc.id) === -1;
        });
    }
}

interface TipoIdentificacionProps {
    name: string,
    className?: string,
    excluir?: Array<string>
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/TipoIdentificacion.tsx